import * as React from 'react';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { grey } from '@mui/material/colors';

export default function RowMarginGrid() {
  const { data, loading } = useDemoData({
    dataSet: 'Commodity',
    rowLength: 200,
    maxColumns: 6,
  });

  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        {...data}
        loading={loading}
        getRowSpacing={getRowSpacing}
        sx={(theme) => ({
          [`& .${gridClasses.row}`]: {
            bgcolor: grey[200],
            ...theme.applyStyles('dark', { bgcolor: grey[900] }),
          },
        })}
      />
    </div>
  );
}
